import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient} from '@angular/common/http';
import { Estabelecimento } from '../../pages/estabelecimentos/estabelecimento';
import { Http } from '@angular/http';
import { LoaderService } from '../loader/loader.service';
import 'rxjs/add/operator/finally';
import { UsuarioEstabelecimento } from '../../pages/usuarios/modal-estabelecimentos/usuarioEstabelecimento';
@Injectable()
export class EstabelecimentoService {

	apiUrl:string;
	constructor(private router: Router, private http: HttpClient, private loader: LoaderService) {
		this.apiUrl = environment.apiUrl;
	}

    buscarEstabelecimento(estabelecimento:string){
        return this.http.get<any[]>(this.apiUrl+"/estabelecimento/buscar/"+estabelecimento);
    }

	carregar(id:number){
		this.loader.show();
		return this.http.get<Estabelecimento>(this.apiUrl + "/estabelecimento/"+id).finally(()=>{
			this.loader.hide();
		});
	}

	listarVinculados(idUsuario){
		this.loader.show();
		return this.http.get<UsuarioEstabelecimento[]>(this.apiUrl + "/estabelecimento/listar-vinculados/"+idUsuario).finally(()=>{
			this.loader.hide();
		});
    }
    
	buscar(busca){
		this.loader.show();
		return this.http.get<Estabelecimento[]>(this.apiUrl + "/estabelecimento/buscar/"+busca).finally(()=>{
			this.loader.hide();
		});
	}

	cadastrar(Estabelecimento:Estabelecimento){
		this.loader.show();
		return this.http.post(this.apiUrl+"/estabelecimento",Estabelecimento).finally(()=>{
			this.loader.hide();
		});
	}

	atualizar(estabelecimento:Estabelecimento){
		this.loader.show();
		return this.http.put(this.apiUrl+"/estabelecimento",estabelecimento).finally(()=>{
			this.loader.hide();
		});
	}

	deletar(id:number){
		this.loader.show();
		return this.http.delete(this.apiUrl+"/estabelecimento/"+id).finally(()=>{
			this.loader.hide();
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/services/estabelecimento/estabelecimento.service.ts